module.exports = __webpack_public_path__ + "static/media/rawkkim-KKz6NgO69yQ-unsplash.fada7d7e.webp";